import { BaseClass } from "./decision.model";
import { SurveyDetail } from "./survey-detail.model";

export class SurveyUser extends BaseClass {
    public email: string;
    public userTypeId: number;
    public surveyDetails: SurveyDetail[] = [];
}